import PropTypes from 'prop-types';
import React, {Component} from 'react';

import CartPropertySelection from './CartPropertySelection'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/pro-light-svg-icons/faCheck";

class CartPropertyInlineSelection extends Component {

    static propTypes = {
        ...CartPropertySelection.propTypes,
        inclusiveLabel: PropTypes.string
    }

    static defaultProps = {
        inclusiveLabel: 'inklusive'
    }

    renderSelection = (handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty) => {

        const propertyOptions = this.props.propertyOptions.map((propertyOption) => {

            const isSelected = selectedProperty === propertyOption.value;

            return (
                <button
                    type="button"
                    key={propertyOption.value}
                    className={"article-inline-selection__selector article-inline-selection__selector--simple" + (isSelected ? ' selected' : '')}
                    onClick={(e) => {
                        handleOptionSelect(propertyOption.value)
                    }}
                >
                    <div>{propertyOption.display.title}</div>
                    {this.props.inclusiveLabel ? <div key={propertyOption.value + "price"}
                                                      className="article-inline-selection__selector__price">{this.props.inclusiveLabel}</div> : null}
                    {isSelected ? <div className={"article-inline-selection__selector__check"}>
                        <FontAwesomeIcon icon={faCheck}/>
                    </div> : null}
                </button>
            )

        })

        return (
            <div
                className={"article-inline-selection article-inline-selection--max-" + (this.props.itemsPerRow ? this.props.itemsPerRow : 2)}>
                {propertyOptions}
            </div>
        )

    }

    render() {

        return (
            <CartPropertySelection
                ref="area"
                propertyOptions={this.props.propertyOptions}
                activeCartProperty={this.props.activeCartProperty}
                selectPropertyCallback={this.props.selectPropertyCallback}
                canClearOnDoubleSelect={false}
            >
                {(handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty) => {
                    return (
                        this.renderSelection(handleOptionSelect, handleOptionDeSelect, defaultOption, selectedProperty)
                    )
                }}
            </CartPropertySelection>
        )

    }

}

export default CartPropertyInlineSelection



/** WEBPACK FOOTER **
 ** ./src/containers/configuration/CartPropertyInlineSelection.js
 **/